import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card", "validated", "ongoing", "started", "permits"];

  getPps() {
    $.get(`/dashboard_pps.json`)
      .done((results) => {
        console.log(results);
      })
      .fail((err) => console.log(err));
  }

  displayPpsForSelectedStatus() {
    const status = event.target.id;
    if (status === "all") {
      this.cardTargets.forEach((card) => card.classList.remove("d-none"));
    } else {
      $.get(`/dashboard_pps.json`)
        .done((results) => {
          this.handleColumn(this.ongoingTargets, results[status]["ongoing"]);
          this.handleColumn(
            this.validatedTargets,
            results[status]["validated"]
          );
          this.handleColumn(this.permitsTargets, results[status]["permits"]);
        })
        .fail((err) => console.log(err));
    }
  }

  handleColumn(columns, results) {
    columns.forEach((column) => {
      const resultsIds = results.map((pp) => pp.id);
      const columnCards = column.querySelectorAll(
        '[data-target="role-selection.card"]'
      );
      columnCards.forEach((card) => {
        if (resultsIds.includes(Number.parseInt(card.dataset.id))) {
          card.classList.remove("d-none");
        } else {
          card.classList.add("d-none");
        }
      });
      // if (Array.from(columnCards).every(card => card.classList.contains('d-none'))) {
      //   column.innerHTML = `
      //     <p class="my-5">Aucun plan de prévention en cours</p>
      //   `
      // }
    });
  }
}
